import React, { createContext, useState, useContext, ReactNode } from 'react';

type RegulatoryFramework = 'NCD' | 'TCF';

interface FrameworkContextType {
  framework: RegulatoryFramework;
  setFramework: (framework: RegulatoryFramework) => void;
}

const FrameworkContext = createContext<FrameworkContextType | undefined>(undefined);

export const FrameworkProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [framework, setFramework] = useState<RegulatoryFramework>('NCD');
  
  return (
    <FrameworkContext.Provider value={{ framework, setFramework }}>
      {children}
    </FrameworkContext.Provider>
  );
};

export const useFramework = (): FrameworkContextType => {
  const context = useContext(FrameworkContext);
  if (context === undefined) {
    throw new Error('useFramework must be used within a FrameworkProvider');
  }
  return context;
};